export default __webpack_public_path__ + "static/char-thumb-31-4e2343dd34c0f432a00a50b04daa30f0.png";